/**
* Testimonials Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

( function( app ) {
  const COMPONENT = {

    className: 'testimonials-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const sliderCounter = 0;
      const sliderElements = '';

      // if ( $( '.testimonials-slider' ).length ) {
      //   sliderCounter++;
      //   if ( sliderElements === '' ) {
      //     sliderElements += '.testimonials-slider';
      //   } else {
      //     sliderElements += ', .testimonials-slider';
      //   }
      // }

      if ( $( '.ll-testimonials-slider__slide' ).length >= 2 ) {
        $( '.ll-testimonials-slider__slider' ).slick( {
          dots: false,
          arrows: true,
          prevArrow: $( '.ll-testimonials-slider__left-arrow' ),
          nextArrow: $( '.ll-testimonials-slider__right-arrow' ),
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 560,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials-slider', COMPONENT );
} )( app );
